module.exports = __webpack_public_path__ + "static/media/builder_add_field_click.fbd99e37.gif";